import { createPropStyling, PropStylingProps } from '../privatePropStylingUtils';

export const backgroundCssAttrNames = [
  'background',
  'backgroundColor',
  'backgroundImage',
  'backgroundPosition',
  'backgroundRepeat',
  'backgroundSize',
] as const;

export type BackgroundCssAttrName = typeof backgroundCssAttrNames[number];

export type BackgroundPropStylingProps = PropStylingProps<BackgroundCssAttrName>;

export const backgroundPropStyling = createPropStyling<BackgroundPropStylingProps>(
  backgroundCssAttrNames,
);
